import React, { useEffect } from 'react';
import Header from './components/Layout/Header';
import HeroSection from './components/Sections/HeroSection';
import WhySection from './components/Sections/WhySection';
import DemoSection from './components/Sections/DemoSection';
import BenefitsSection from './components/Sections/BenefitsSection';
import PricingSection from './components/Sections/PricingSection';
import ContactSection from './components/Sections/ContactSection';
import Footer from './components/Layout/Footer';
import ArchitecturalBackground from './components/UI/ArchitecturalBackground';
import './App.css';

const App: React.FC = () => {
  useEffect(() => {
    // Add smooth scroll effect for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(this: HTMLAnchorElement, e) {
        e.preventDefault();
        
        const href = this.getAttribute('href');
        if (href) {
          const target = document.querySelector(href);
          if (target) {
            window.scrollTo({
              top: (target as HTMLElement).offsetTop - 100,
              behavior: 'smooth'
            });
          }
        }
      });
    });
    
    // Preload background elements to prevent initial rendering glitches
    window.addEventListener('load', () => {
      document.documentElement.classList.add('background-loaded');
    });
  }, []);

  return (
    <div className="app" style={{ minHeight: '200vh' }}> {/* Ensure enough height for scrolling */}
      {/* Dynamic Architectural Background with variety of elements */}
      <ArchitecturalBackground numberOfElements={2} />
      
      <Header />
      <main>
        <HeroSection />
        {/* Add ID to WhySection */}
        <section id="why">
          <WhySection />
        </section>
        {/* Add ID to DemoSection */}
        <section id="demo">
          <DemoSection />
        </section>
        <BenefitsSection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;